var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlightExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 42,
    cy: 42,
    r: 42,
    transform: "rotate(-180 42 42)",
    fill: "url(#paint0_linear_302_4)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 70C38.0333 70 34.3467 69.2883 30.94 67.865C27.5333 66.4417 24.57 64.47 22.05 61.95C19.53 59.43 17.5583 56.4667 16.135 53.06C14.7117 49.6533 14 45.9667 14 42C14 38.08 14.7117 34.4167 16.135 31.01C17.5583 27.6033 19.53 24.64 22.05 22.12C24.57 19.6 27.5333 17.6167 30.94 16.17C34.3467 14.7233 38.0333 14 42 14C45.92 14 49.5833 14.7233 52.99 16.17C56.3967 17.6167 59.36 19.6 61.88 22.12C64.4 24.64 66.3833 27.6033 67.83 31.01C69.2767 34.4167 70 38.08 70 42C70 45.9667 69.2767 49.6533 67.83 53.06C66.3833 56.4667 64.4 59.43 61.88 61.95C59.36 64.47 56.3967 66.4417 52.99 67.865C49.5833 69.2883 45.92 70 42 70ZM42 34.02C42.6533 34.02 43.2017 33.81 43.645 33.39C44.0883 32.97 44.31 32.4333 44.31 31.78C44.31 31.1267 44.0883 30.5667 43.645 30.1C43.2017 29.6333 42.6533 29.4 42 29.4C41.3467 29.4 40.7983 29.6333 40.355 30.1C39.9117 30.5667 39.69 31.1267 39.69 31.78C39.69 32.4333 39.9117 32.97 40.355 33.39C40.7983 33.81 41.3467 34.02 42 34.02ZM40.11 56H44.31V39.2H40.11V56Z",
    fill: "#FF8000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_302_4",
    x1: 42,
    y1: 0,
    x2: 42,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.476087,
    stopColor: "#FF8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8000",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightExpired);
export default __webpack_public_path__ + "static/media/flightExpired.683d3c49fdce629a2b3cacfcc75f1524.svg";
export { ForwardRef as ReactComponent };